module.exports = __webpack_public_path__ + "img/transport_back.9c4d6402.png";